// core/services/auth.api.ts
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpContext } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { UrlService } from '../../services/url.service';
import { LOADER_OPTS } from '../interceptors/loader.tokens';

export const SKIP_GLOBAL_LOADER = new (class extends HttpContext { })() as any; // or your own HttpContextToken flag

@Injectable({ providedIn: 'root' })
export class AuthApi {
  private http = inject(HttpClient);
  private urls = inject(UrlService);

  login$(username: string, password: string) {
    const base = this.urls.getUrl();
    const url  = `${base}/ws/Settings/SettingsArea.ashx`;
    const body = { typeHandler: 'Login' };
    const headers = new HttpHeaders({ Authorization: 'Basic ' + btoa(`${username}:${password}`) });
    const context = new HttpContext().set(LOADER_OPTS, { label: 'Autenticazione…' });

    return this.http.post<any>(url, body, { headers, context }).pipe(
      map(res => {
        if (!res?.Token) throw new Error('INVALID_CREDENTIALS');
        return {
          token: res.Token as string,
          authHeader: 'Basic ' + btoa(`${username}:${password}`)
        };
      })
    );
  }
}
